import { render, staticRenderFns } from "./ImgFallback.vue?vue&type=template&id=ba4607e2&"
import script from "./ImgFallback.vue?vue&type=script&lang=js&"
export * from "./ImgFallback.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ba4607e2')) {
      api.createRecord('ba4607e2', component.options)
    } else {
      api.reload('ba4607e2', component.options)
    }
    module.hot.accept("./ImgFallback.vue?vue&type=template&id=ba4607e2&", function () {
      api.rerender('ba4607e2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2XIXAN5488smZ/JS/comp/ImgFallback.vue"
export default component.exports